var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.434 11.285v3.03h18.182l-8.334 8.333 2.152 2.152 12-12-12-12-2.152 2.152 8.334 8.333H.434z",
    fill: "#0E6FFF"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNDMzOTYgMTEuMjg0OVYxNC4zMTUySDE4LjYxNThMMTAuMjgyNCAyMi42NDg1TDEyLjQzNCAyNC44TDI0LjQzNCAxMi44TDEyLjQzNCAwLjgwMDA0OUwxMC4yODI0IDIuOTUxNTZMMTguNjE1OCAxMS4yODQ5SDAuNDMzOTZaIiBmaWxsPSIjMEU2RkZGIi8+Cjwvc3ZnPgo=";
export { SvgArrowRight as ReactComponent };